<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de Responsabilidad Civil por Daños a Terceros</h1>
                <p>En el ejercicio de su actividad económica, su empresa está expuesta a algunos riesgos que pueden
                ocasionar daños a terceros. Proteja su patrimonio con esta opción que te ofrecemos.
                </p>
        </div>
        <div class="especialidades-slide">
            <center><h1>Este seguro de responsabilidad civil cubre:</h1>
            <VueSlickCarousel
                class="slider2"
                ref="slick"
                v-bind="slickOptionsExperiencies"
                :arrows="false">
                <div v-for="(slide, i) in especialidades" :key="i" class="especial">
                    <img :src="slide.image" alt="">
                    <p>{{slide.texto}}</p>
                </div>
            </VueSlickCarousel>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Algunos riesgos en su empresa se pueden identificar, otros no son tan evidentes y pueden afectar su patrimonio, sobre todo cuando
                hay terceras personas involucradas. Si los imprevistos se salen de control, el Seguro de Responsabilidad Civil por Daños a Terceros
                responde por su tranquilidad.
                <br>
                <br>
                Este seguro cubre los gastos de indemnización generados por daños materiales o lesiones personales ocasionados en el ejercicio de su
                actividad empresarial. De este modo, cuida su tranquilidad y la de su empresa de una manera tangible, protegiéndola si un evento
                desafortunado la pone en peligro.
                <br>
                <br>
                Lo mejor es que puede concentrarse en trabajar por construir el futuro de su empresa, mientras que lo respaldamos. ¡Confíe en nosotros y
                <span>permítanos asesorarlo!</span>
                </p>
            </center>
        </div>
        <div class="slide-cobertura-principal">
            <center><h1>¿Qué cubre?</h1></center>
            <center><img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt=""><label for="">Coberturas principales</label></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaPrincipal" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="slide-cobertura-opcional">
            <center><img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt=""><label for="">Coberturas opcionales</label></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="opcionales">
            <center><h1>¿Qué no cubre?</h1></center>
            <div v-for="(opcional, i) in opcionales" :key="i" class="opcional">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{opcional.p}}</p>
            </div>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresas se pueden asegurar?</h1>
            <p>Cualquier empresa que desee asegurarse ante la responsabilidad civil y quiera proteger el patrimonio de su empresa. Debe ser apta luego de
            un análisis de riesgo realizado por la asesuradora.</p>
        </div>
        <div class="opcionales">
            <center><h1>Tarifa del seguro</h1></center>
            <div class="opcional">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>La prima del seguro se establecerá de acuerdo a la actividad económica de la empresa.</p>
            </div>
        </div>
        <div class="move"><center><img src="@/assets/Responsabilidad-civil-danos-terceros/5.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Responsabilidad-civil-danos-a-terceros',
    metaInfo() {
        return {
            title: 'Seguro de Responsabilidad Civil por Daños a Terceros',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'En el ejercicio de su actividad económica, su empresa está expuesta a algunos riesgos que pueden ocasionar daños a terceros. Proteja su patrimonio con esta opción que te ofrecemos.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            especialidades: [
                {
                    image: require('@/assets/Responsabilidad-civil-danos-terceros/1.png'),
                    texto: 'Gastos incurridos por ocasionar daños materiales o personales a terceros.'
                },
                {
                    image: require('@/assets/Responsabilidad-civil-danos-terceros/2.png'),
                    texto: 'Muerte o lesiones de sus empleados por accidentes laborales en los que su empresa sea responsable.'
                },
                {
                    image: require('@/assets/Responsabilidad-civil-danos-terceros/3.png'),
                    texto: 'Daños a terceros por sus empleados en el exterior.'
                },
                {
                    image: require('@/assets/Responsabilidad-civil-danos-terceros/4.png'),
                    texto: 'Gastos médicos y de defensa.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            opcionales: [
                {
                    p: 'Incumplimiento de las obligaciones de un contrato.'
                },
                {
                    p: 'Contaminación paulatina.'
                },
                {
                    p: 'Enfermedades profesionales.'
                },
                {
                    p: 'Cuando los daños sean causados a bienes que usted tenga bajo su control, cuidado o custodia o cuando estos bienes desaparezcan o sean hurtados.'
                },
                {
                    p: 'Indemnización de carácter sancionatorio.'
                },
                {
                    p: 'Responsabilidad civil profesional.'
                },
                {
                    p: 'Enfermedades profesionales.'
                },
                {
                    p: 'Hurto de elementos dejados dentro de los vehículos.'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Daños causados a terceros con vehículos a su servicio',
                    p: 'Cubre los daños materiales, lesiones personales o muerte causados a terceros con vehículos que estén a su servicio, sean o no de su propiedad. Esta cobertura opera en exceso del SOAT, el seguro voluntario del vehículo o, en caso de no tener este último, de 136 salarios mínimos mensuales legales vigentes.'
                },
                {
                    label: 'Productos inseguros-defectuosos',
                    p: 'Cubre los daños materiales, lesiones personales o muerte causados a terceros por productos inseguros fabricados, comercializados o entregados por usted'
                },
                {
                    label: 'Productos inseguros-defectuosos-exportados',
                    p: 'Cubre los daños que ocasione su empresa a causa de productos defectuosos exportados a todo el mundo, excepto a Canadá, Estados Unidos y Puerto Rico.'
                },
                {
                    label: 'Unión, mezcla o transformación de productos',
                    p: 'Aplica para empresas que durante sus procesos productivos requieren insumos de otras compañías y pueden exponerse a dañarlos o deteriorarlos.'
                }
            ],
            coberturaPrincipal: [
                {
                    label: 'Predios y operaciones',
                    p: 'Cubre la responsabilidad civil en que incurra la empresa por daños materiales, lesiones personales o muerte causados a terceros en sus predios o por las operaciones que lleva a cabo dentro y fuera de los mismos.'
                },
                {
                    label: 'Responsabilidad civil contratistas y subcontratistas',
                    p: 'Cubre los daños causados a las personas o a sus bienes por los contratistas y subcontratistas de su empresa en el desarrollo de sus labores.'
                },
                {
                    label: 'Responsabilidad del empleador',
                    p: 'Cubre la muerte o lesiones personales de sus empleados en caso de accidentes cuando usted como empleador no les garantice seguridad para desempeñar su labor. Esta cobertura opera en exceso de la Seguridad Social.'
                },
                {
                    label: 'Viajes al exterior',
                    p: 'Cubre los daños materiales, lesiones personales o muerte causados a terceros por funcionarios o empleados en el desempeño de sus obligaciones laborales durante viajes al exterior. Deben ser viajes que no excedan las cinco semanas.'
                },
                {
                    label: 'Daños al inmueble arrendado',
                    p: 'Cubre los daños causados al lugar en el que su empresa desarrolle sus actividades'
                },
                {
                    label: 'Bienes bajo cuidado, tenencia y control',
                    p: 'Cubre los daños causados con los bienes que tiene bajo su cuidado, tenencia y control (tanto si son de su propiedad como si son prestados o alquilados'
                },
                {
                    label: 'Responsabilidad civil cruzada',
                    p: 'Cubre los daños que se causen diferentes compañías que pertenecen a un mismo grupo empresarial'
                },
                {
                    label: 'Parqueadero',
                    p: 'Se asumen los daños o el hurto de los vehículos que se encuentren en los parqueaderos de la empresa, siempre y cuando estos tengan vigilancia y se encuentren en espacios demarcados para el aparcamiento (celdas definidas).'
                },
                {
                    label: 'Gastos médicos de atención inicial de urgencias',
                    p: 'Cubre los servicios inmediatos de primeros auxilios que se presten si ocurre una urgencia con un tercero. Este puede ser llevado a un centro médico sin importar si usted es responsable o no del accidente.'
                },
                {
                    label: 'Gastos de defensa en procesos civiles y penales',
                    p: 'Cubre los gastos para defenderse de cualquier reclamación que le presente un tercero por alguna de las responsabilidades incluidas en este seguro. Además, se asumen los gastos de defensa en procesos penales cuando sean consecuencia de un evento de responsabilidad civil'
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Su patrimonio en caso de hurto, falsedad, estafa o abuso de confianza de sus empleados.',
                            img: require('@/assets/Empresarial-Fraude-Empleados/1.png')
                        },
                        {
                            text: 'Pérdidas causadas por trabajadores no identificados.',
                            img: require('@/assets/Empresarial-Fraude-Empleados/2.png')
                        },
                        {
                            text: 'Las pérdidas de bienes pertenecientes a terceros.',
                            img: require('@/assets/Empresarial-Fraude-Empleados/3.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div > p{
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .slide-cobertura-principal > center > img{
        width: 50px;
        margin-right: 20px;
    }
    .slide-cobertura-principal > center > label{
        color: #65b24a;
        font-family: 'JBD';
    }
    .slide-cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .slide-cobertura-opcional > center > img{
        width: 50px;
        margin-right: 20px;
    }
    .slide-cobertura-opcional > center > label{
        color: #65b24a;
        font-family: 'JBD';
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/ResponsavilidadCivilDanoTerceros.vue